module.exports = __webpack_public_path__ + "static/img/5.043dfeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/5.png
// module id = 3HPM
// module chunks = 0